<template>
  <div class="install">
    <div>
      <div v-if="(transaction && transaction.status != -1) || !transaction">
        <h4 v-if="steps[step]">
          {{ partner.name }} -
          {{ step | setText(steps[step].title) }}
        </h4>
        <template v-for="(value, stepKey) in steps">
          <template v-if="step == stepKey">
            <component
              :createTransaction="createTransaction"
              :updateOrder="updateOrder"
              :transaction="transaction"
              :order="order"
              :partner="partner"
              :partner_id="partner_id"
              :is="stepKey"
              @setStep="setStep"
              :key="stepKey"
              v-model="body"
            />
          </template>
        </template>
      </div>
      <div v-else-if="transaction" class="text-center text-danger">
        <h2 class="ti-close"></h2>
        <h2 class="text-uppercase">
          Заказ отменен # {{ transaction.exchange_id }}
        </h2>
        <h4>
          {{ order.client.full_name }}
        </h4>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    setStep(step = null) {
      if (!step) {
        this.$emit("close", true);
      } else {
        this.step = step;
      }
    },
  },
  components: {
    "client-check": () => import("./ClientCheck"),
    "order-add": () => import("./OrderAdd"),
    "order-confirm": () => import("./OrderConfirm"),
    "order-done": () => import("./OrderDone"),
  },
  created() {
    try {
      if (
        this.transaction &&
        this.transaction.step &&
        this.steps[this.transaction.step]
      ) {
        this.step = this.transaction.step;
      }
    } catch (error) {}
  },
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed
      );
    },
  },
  data() {
    return {
      body: null,
      step: "client-check",
      steps: {
        "client-check": {
          title: "Проверка клиента", //0
          key: "client-check",
        },
        "order-add": {
          title: "Создание заказа", //2
          key: "order-add",
        },
        "order-confirm": {
          title: "Подтверждение заказа", //3
          key: "order-confirm",
        },
        "order-done": {
          title: "Завершение заказа", //3
          key: "order-confirm",
        },
      },
    };
  },
};
</script>

